module.exports = __webpack_public_path__ + "img/rh.4c3b4572.png";